export const SVG_MARGIN_SIZE = 30;
export const RULER_WIDTH = 20;
export const TOOLBAR_WIDTH = 75;
export const NAVIGATOR_WIDTH = 150;
export const SIDEBAR_WIDTH = 250;
export const HEADER_HEIGHT = 50;
export const PREVIEW_PADDING = 10;
export const INITIAL_PATTERN_WIDTH = 22678;
export const INITIAL_PATTERN_HEIGHT = 11339;
export const PIECE_MARGIN_SIZE = 100;
export const PATTERN_MARGIN_SIZE = 25;
export const KNOT_SNAP_THRESHOLD_LIMIT = 7;
